import { List } from 'immutable';
import UnitQuizResult from './model';
import UnitQuizSkillResult from './UnitQuizSkillResult';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'unitId':
      return [key, `${val}`];
    case 'skillResults':
      return [key, new List(val.map((skillResult) => UnitQuizSkillResult.create(skillResult)))];
    default:
      return [key, val];
  }
};

const create = (data) => new UnitQuizResult(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/UnitQuiz/model/UnitQuizResult/create.js